import React from "react";
import { FormattedMessage } from "react-intl";

export default function DataLoadError() {
  return (
    <div className="text-center p-4">
      <FormattedMessage id="CouldNotLoadData" />
    </div>
  );
}
